package devxertech.com.pages.blogs.blogPages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.alignItems
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.justifyContent
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.component.CommonButton
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Res
import kotlinx.browser.window
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.H2

@Composable
fun ConclusionSection(
    lead: String = "AI in 2025 is transforming business at every level from internal efficiency " +
        "to external experience. It helps companies act faster, innovate smarter, and serve better. " +
        "Those who adopt it now are setting themselves apart from competitors who still rely on outdated systems. ",
    highlighted: String = "DEVXER Technology ",
    trailing: String = "we help forward-thinking businesses unlock the true potential of AI " +
        "from strategy to execution. The future belongs to those who build it. Let’s build it intelligently."
) {
    val breakpoint = rememberBreakpoint()
    val sitePalette = ColorMode.current.toSitePalette()
    val ctx = rememberPageContext()

    Row(
        modifier = Modifier
            .fillMaxWidth()
            .justifyContent(JustifyContent.Center)
            .alignItems(AlignItems.Center)
            .gap(40.px)
            .flexWrap(FlexWrap.Wrap),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.Center
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth(if (breakpoint < Breakpoint.MD) 100.percent else if (breakpoint == Breakpoint.MD || breakpoint == Breakpoint.LG)
                    93.percent else 64.percent)
                .padding(topBottom = 60.px, leftRight = if (breakpoint < Breakpoint.MD) 20.px else 0.px)
                .gap(0.px),
            horizontalAlignment = Alignment.Start
        ) {
            // ▶ CONCLUSION heading
            H2(attrs = { style { property("display", "flex"); property("margin", "0") } }) { Row(
                modifier = Modifier.gap(6.px),
                horizontalArrangement = Arrangement.Start,
                verticalAlignment = Alignment.CenterVertically
            ) {
                Image(
                    src = Res.Image.blog_arrow,
                    description = "",
                    modifier = Modifier
                        .size(15.px)
                        .color(sitePalette.topBarMenuText.rgb)
                )
                SpanText(
                    text = "CONCLUSION",
                    modifier = Modifier
                        .fontSize(if (window.screen.width > 1600) 24.px else 20.px)
                        .fontWeight(FontWeight.Bold)
                        .color(sitePalette.topBarMenuText.rgb)
                )
            } }

            Row(
                modifier = Modifier
                    .flexWrap(FlexWrap.Wrap)
                    .margin(top = 10.px, left = 20.px)
            ) {
                ColoredText(
                    text = lead,
                    color = sitePalette.commonSecondaryButtonColor.rgb
                )
                ColoredText(
                    text = "At ",
                    color = sitePalette.commonSecondaryButtonColor.rgb
                )
                ColoredText(
                    text = highlighted,
                    color = sitePalette.primary.rgb,
                    weight = 600
                )
                ColoredText(
                    text = trailing,
                    color = sitePalette.commonSecondaryButtonColor.rgb
                )
            }

            // BACK button
            Box(
                modifier = Modifier
                    .margin(top = 25.px, left = 20.px),
                contentAlignment = Alignment.Center
            ) {
                CommonButton(text = "BACK", blogButton = true, onClick = {}, linkPath = "/blogs")
            }
        }
    }
}


@Composable
fun ColoredText(
    text: String,
    color: CSSColorValue,
    weight: Int = 400
) {
    SpanText(
        text = text,
        modifier = Modifier
            .color(color)
            .fontSize(if (window.screen.width > 1600) 18.px else 16.px)
            .lineHeight(if (window.screen.width > 1600) 30.px else 25.px)
            .fontWeight(weight)
            .whiteSpace(WhiteSpace.Normal)
    )
}
